module.exports = __webpack_public_path__ + "img/vscode.f25685e.webp";